import { CART_MODULE } from "@/api_framework/api_config";
import { ICartFilterBody, ICartListResponse } from "@/api_framework/api_modals/Cart";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import { useAPIUtils } from "../../useAPIUtils";
import { ICartState, setCartList, setUnbilledCart } from "@/app_redux/reducers/slices/auth/cart_slice";
import { useRouter } from "../../useRouter";
import useRouteInfo from "../../useRouteInfo";

AxiosCurlirize(axios, () => {});
type ICartAPIResponse = { status: boolean; message: any };

export const useCartListAPI = () => {
  const { getRouteKey } = useRouter();
  const { unbilledCart } = useRouteInfo(getRouteKey("CART_MANAGEMENT", "id")).routeState.state as ICartState;

  const configuration = useConfiguration();

  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (filterBody: ICartFilterBody, customerId: string) => {
      dispatch(
        setLoading({
          key: "isCustomerCartListTableInProgress",
          status: true,
        }),
      );
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: ICartAPIResponse = await axios
          .post(`${CART_MODULE?.CART_LIST?.baseURL}/${customerId}`, filterBody, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<any>) => {
            dispatch(
              setLoading({
                key: "isCustomerCartListTableInProgress",
                status: false,
              }),
            );

            const numberOfCartItems = res.data?.data?.total_items;
            if (res.data.status === true) {
              dispatch(setUnbilledCart(numberOfCartItems));
              return { status: true, message: res.data.data };
            } else {
              dispatch(setUnbilledCart(0));
              return { status: false, message: null };
            }
          })
          .catch((e: AxiosError) => {
            dispatch(setUnbilledCart(0));
            dispatch(setCartList([]));
            dispatch(
              setLoading({
                key: "isCustomerCartListTableInProgress",
                status: false,
              }),
            );
            sendCurl(e.config["curlCommand"]);
            // captureError(e)
            return { status: false, message: null };
          });
        return response;
      } catch (e) {
        dispatch(setUnbilledCart(0));
        dispatch(setCartList([]));
        captureError(e);
      }
    },
    [dispatch],
  );
  return { execute };
};
